import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HhsgSharedFormStateService } from '../../services';


@Component({
	template: ''
})  
export class HhsgSharedAdminBaseComponent {
	displayDeactivation: boolean = false;

	constructor(
        public _baseFormStateService: HhsgSharedFormStateService,
		public _baseRouter: Router) {

	}
	
	canDeactivate(component, route, state, nextState): boolean {
		if (this._baseFormStateService.isFormDirty) {
			this._baseFormStateService.continueRoute = nextState;
			this.displayDeactivation = true;
			return false;
		}

		return true;
	}

	onDeactivateContinueEditing() {
        this.displayDeactivation = false;
	}

	onDeactivateLeavePage() {
		this.displayDeactivation = false;
		this._baseFormStateService.isFormDirty = false;
		if (this._baseFormStateService.isNextActionFunction) {
			this._baseFormStateService.continueFunc.apply(this, this._baseFormStateService.continueArgs);
		}
		else if (this._baseFormStateService.isNextActionNavigation) {
			this._baseRouter.navigateByUrl(this._baseFormStateService.continueRoute.url.toString());
		}
		this._baseFormStateService.reset();
	}
}